import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: "600px",
    borderRadius: 0,
    "& td": {
      width: "100px",
    },
    "& thead tr": {
      backgroundColor: "rgba(179,175,175,0.1)",
    },
    "& tbody tr": {
      "&:nth-child(even)": {
        backgroundColor: "rgba(179,175,175,0.1)",
      },
    },
    "& tbody tr:hover": {
      backgroundColor: "#fffbf2",
      cursor: "pointer",
    },
    "& thead th": {
      color: "black",
      border: "1px solid rgba(0, 0, 0, 0.1)",
    },
    "& tbody td": {
      fontWeight: "300",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      textTransform: "uppercase",
    },
  },
  pageContent: {
    borderRadius: 0,
    borderTop: "none",
    backgroundColor: "transparent",
  },
  actionButtonRoot: {
    color: "gray",
    padding: theme.spacing(0.1),
  },
  delete: {
    color: theme.palette.deleteColor,
  },
  searchInput: {
    "& .Mui-focused": {
      "& .MuiSvgIcon-root": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  toolbar: {
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  toolbarSearch: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  toolbarActionContainer: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-between",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      padding: theme.spacing(1),
    },
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  checkBoxTableCell: {
    textAlign: "center",
    maxWidth: "5px",
    padding: 5,
  },
  checkBox: {
    padding: 0,
    margin: 0,
    width: "100%",
    color: "black",
  },
}));

export default useStyles;
